import { views } from './../../../shared/models/home/views';
import { Injectable } from "@angular/core";
import { HomeProvider } from "app/core/services/requests/provider/home/home.provider";

import { RootObjectViews } from "app/shared/models/home/views";
import { ToastrService } from "ngx-toastr";

import { RootObjectTrainingsDash, TrainingsDash } from 'app/shared/models/home/tariningsDash';
import { DataDash } from 'app/shared/models/home/dataDash';



@Injectable({
  providedIn: "root",
})
export class HomeService {
  codeId: number = 0;

  constructor(private home: HomeProvider, private toastrService: ToastrService) { }
 
  getDataDash(): Promise<DataDash> {
    return new Promise((resolve, reject) => {
      this.home.getInfosDash()
        .get()
        .subscribe(
          (res) => {
            resolve(res)
          },
          (err: any['message']) => {
            this.toastrService.error(`Ocorreu um erro ao obter dados de aceites de políticas...${err}`, "", {
              timeOut: 2000,
            });
            reject(err)
          }
        );
    })
  }
  getInformation(idEmpresa) {
    let x = new Date();
    let di = new Date(`${x.getFullYear()}" "${x.getMonth() - 1}+" "${x.getDay()}`);
    let df = new Date(`${x.getFullYear()}" "${x.getMonth()}+" "${x.getDay()}`);
    return new Promise((resolve, reject) => {
      this.home
        .listInfos()
        .getListObj({ empresaId: idEmpresa, dataInicial: di.toISOString(), dataFinal: df.toISOString() })
        .subscribe(
          (res) => {
            resolve(res);

          },
          (err) => {

            reject(err);
          }
        );
    })
  }
  getTrainings(): Promise<RootObjectTrainingsDash['data']> {
    return new Promise((resolve, reject) => {
      this.home.listTrainingsStatus()
        .get()
        .subscribe((res) => {
          resolve(res);
        }, (err) => {
          reject(err);
        })
    })
  }
  methodDate(data: string): string {
    return new Date(data).toLocaleDateString();
  }
}
